import React from 'react';

import { Divider } from '@mui/material';
import { BulletedListIcon } from 'src/components/icons/BulletedListIcon';
import { NumberedListIcon } from 'src/components/icons/NumberedListIcon';
import { makeStyles } from 'tss-react/mui';

import { AlignmentButtons } from './AlignmentButtons';
import { ClearFormatButton } from './ClearFormatButton';
import { FontColorSelect } from './FontColorSelect';
import { FontSizeSelect } from './FontSizeSelect';
import { FontStyleSelect } from './FontStyleSelect';
import { FontTypeSelect } from './FontTypeSelect';
import { HighlightColorSelect } from './HighlightColorSelect';
import { LineSpacingMenu } from './LineSpacingMenu';
import { ListButton } from './ListButton';
import { ParagraphColorSelect } from './ParagraphColorSelect';
import { TextFormatButtons } from './TextFormatButtons';
import { TextSizeButtons } from './TextSizeButtons';
import { UndoRedoButtons } from './UndoRedoButtons';
import { ButtonsBarWithOverflowMenu } from '../shared/ButtonsBarWithOverflowMenu';

const useStyles = makeStyles()(theme => ({
  divider: {
    height: 24,
    marginLeft: theme.spacing(0.8),
    marginRight: theme.spacing(0.8),
  },
}));

export function HomeTabBar() {
  const { classes } = useStyles();

  return (
    <ButtonsBarWithOverflowMenu>
      <UndoRedoButtons />
      <FontStyleSelect />
      <FontTypeSelect />
      <FontSizeSelect />
      <TextSizeButtons />
      <TextFormatButtons />
      <FontColorSelect />
      <HighlightColorSelect />
      <ParagraphColorSelect />
      <ClearFormatButton />
      <Divider className={classes.divider} orientation="vertical" />
      <AlignmentButtons />
      <LineSpacingMenu />
      <ListButton
        icon={<NumberedListIcon />}
        listDefinitionIndices={[0, 1, 2, 3, 4, 5]}
        tooltipTitle="Numbered list"
      />
      <ListButton
        icon={<BulletedListIcon />}
        listDefinitionIndices={[6, 7, 8, 9, 10, 11]}
        tooltipTitle="Bulleted list"
      />
    </ButtonsBarWithOverflowMenu>
  );
}
